import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const ALLOWED_TRANSITIONS = {
  borrador: ['emitida', 'anulada'],
  emitida: ['pagada', 'vencida', 'anulada'],
  pagada: [],
  vencida: ['pagada', 'anulada'],
  anulada: [],
};

const COLUMN_LABELS = {
  borrador: 'Borrador',
  emitida: 'Emitida',
  pagada: 'Pagada',
  vencida: 'Vencida',
  anulada: 'Anulada',
};

const DocumentoLegalCard = ({
  documento,
  onCardClick,
  onEdit,
  onDelete,
  onChangeEstado,
  formatCurrency,
  formatDate,
  overlay = false,
}) => {
  const [showEstadoMenu, setShowEstadoMenu] = useState(false);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: documento.id, disabled: overlay });

  const style = overlay
    ? {}
    : {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
      };

  const transitions = ALLOWED_TRANSITIONS[documento.estado] || [];

  const getTipoBadgeClass = (tipo) => {
    const tipoMap = {
      factura_compra: 'badge-factura-compra',
      factura_venta: 'badge-factura-venta',
      boleta: 'badge-boleta',
      nota_credito: 'badge-nota-credito',
      nota_debito: 'badge-nota-debito',
    };
    return tipoMap[tipo] || 'badge-default';
  };

  const handleCardClick = (e) => {
    if (e.target.closest('.docleg-card-actions') || e.target.closest('.docleg-estado-menu')) return;
    onCardClick(documento.id);
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(overlay ? {} : { ...attributes, ...listeners })}
      className={`docleg-card ${isDragging ? 'dragging' : ''} ${overlay ? 'docleg-card-overlay' : ''}`}
      onClick={handleCardClick}
    >
      {/* Row 1: Number + Type badge */}
      <div className="docleg-card-header">
        <span className="docleg-card-numero">
          {documento.numero_documento}
          {documento.contabilizado && (
            <span className="badge-contabilizado" title="Contabilizado">&#10003;</span>
          )}
        </span>
        <span className={`badge ${getTipoBadgeClass(documento.tipo_documento)}`}>
          {documento.tipo_documento_display}
        </span>
      </div>

      {/* Row 2: Provider/Client */}
      <div className="docleg-card-body">
        {documento.proveedor_nombre || documento.cliente_nombre || 'Sin asignar'}
      </div>

      {/* Row 3: Amount */}
      <div className="docleg-card-amount">
        {formatCurrency(documento.monto_total)}
      </div>

      {/* Row 4: Date + Actions */}
      <div className="docleg-card-footer">
        <span className="docleg-card-date">
          {formatDate(documento.fecha_emision)}
        </span>
        <div className="docleg-card-actions" onClick={(e) => e.stopPropagation()}>
          {transitions.length > 0 && (
            <div style={{ position: 'relative' }}>
              <button
                className="btn-icon btn-icon-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowEstadoMenu(!showEstadoMenu);
                }}
                title="Cambiar estado"
              >
                &#8644;
              </button>
              {showEstadoMenu && (
                <div className="docleg-estado-menu">
                  {transitions.map((est) => (
                    <button
                      key={est}
                      onClick={(e) => {
                        e.stopPropagation();
                        onChangeEstado(documento.id, est);
                        setShowEstadoMenu(false);
                      }}
                    >
                      {COLUMN_LABELS[est]}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
          <button
            className="btn-icon btn-icon-sm"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(documento);
            }}
            title="Editar"
          >
            &#9998;
          </button>
          <button
            className="btn-icon btn-icon-sm btn-danger"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(documento.id);
            }}
            title="Eliminar"
          >
            &#128465;
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentoLegalCard;
